import * as Yup from 'yup';

import { EMAIL_MATCHES } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { VALIDATION_FIRST_NAME, VALIDATION_LAST_NAME } from '@uplift/validations';

export const useAddSessionValidationSchema = () => {
  const l10n = useL10n();

  return Yup.object().shape({
    invitedPatient: Yup.object().when([ 'isNewPatient', 'isPsychiatrist' ], {
      is: (isNewPatient: boolean, isPsychiatrist: boolean) => isNewPatient && !isPsychiatrist,
      then: s => s.shape({
        firstName: VALIDATION_FIRST_NAME.required(l10n.validations.newClientFirstName),
        lastName: VALIDATION_LAST_NAME.required(l10n.validations.newClientLastName),
        email: Yup.string()
          .email(l10n.validations.invalidEmail)
          .matches(EMAIL_MATCHES, l10n.validations.invalidEmail)
          .required(l10n.validations.required)
      }),
    }).when([ 'isNewPatient', 'isPsychiatrist' ], {
      is: (isNewPatient: boolean, isPsychiatrist: boolean) => isNewPatient && isPsychiatrist,
      then: s => s.shape({
        firstName: VALIDATION_FIRST_NAME.required(l10n.validations.newClientFirstName),
        lastName: VALIDATION_LAST_NAME.required(l10n.validations.newClientLastName),
        email: Yup.string()
          .email(l10n.validations.invalidEmail)
          .matches(EMAIL_MATCHES, l10n.validations.invalidEmail)
          .required(l10n.validations.required),
      }),
    }),
    existingPatient: Yup.mixed().nullable()
      .when('isNewPatient', {
        is: false,
        then: s => s.required(l10n.validations.required),
        otherwise: s => s.notRequired(),
      }),
    duration: Yup.string().nullable().required(l10n.validations.required),
    repeats: Yup.string().required(l10n.validations.required),
    date: Yup.string().nullable().required(l10n.validations.required),
    startTime: Yup.string().nullable().required(l10n.validations.required),
    notes: Yup.string().max(250, (info) => l10n.validations.tooLongIndicator(info.max, info.value.length)),
  });
};
